/**
 * Chaves de cache dos contratos especiais do EC (#1091 F3), prefixadas com `['org', orgId]`
 * (frontend-apps/CONVENTIONS.md): o QueryClient sobrevive ao logout, e uma chave sem a org
 * entregaria a outra pessoa, na mesma aba, a lista e o detalhe do cliente anterior — sem passar
 * pela tenancy do backend.
 */
export const chavesDosContratosEspeciais = {
  lista: (orgId: string | null) => ['org', orgId, 'special-contracts'] as const,
  detalhe: (orgId: string | null, id: string) => ['org', orgId, 'special-contracts', id] as const,
}
